import React, { useEffect, useState } from "react";
import { fetchDashboardStats } from "./api";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";

function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("admin")) {
      navigate("/admin/login");
      return;
    }

    fetchDashboardStats()
      .then((data) => {
        if (data.status === "success") {
          setStats(data);
        } else {
          setError(data.message || "Failed to load dashboard data.");
        }
      })
      .catch(() => {
        setError("Failed to load dashboard data. Please try again later.");
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("admin");
    navigate("/admin/login");
  };

  if (loading) return <div className="text-center mt-5 text-white">Loading dashboard...</div>;
  if (error) return <div className="text-danger text-center mt-5">{error}</div>;

  const generalCards = [
    ["📅 Total Appointments", stats.appointments],
    ["🎉 Total Events", stats.events],
    ["🛠️ Our Services", stats.services],
    ["📨 Contact Queries", stats.contact_us],
    ["🩸 Blood Donations", stats.blood_donations],
    ["👨‍⚕️ Registered Doctors", stats.doctors],
    ["📋 ED Portal Queries", stats.custom_form],
    ["🧑‍🤝‍🧑 Registered Patients", stats.users],
    ["🧑‍🤝‍🧑 Total Subscribers", stats.subscriptions],
  ];

  return (
    <div className="admin-dashboard d-flex flex-column flex-lg-row min-vh-100 text-white">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="fw-bold">📁 Admin Menu</h5>
          <button
            className="btn btn-sm d-lg-none text-white"
            onClick={() => setSidebarOpen(false)}
          >
            ❌
          </button>
        </div>
        <ul className="nav flex-column">
          <li className="nav-item mb-3">
            <span className="nav-link active text-white fw-semibold">📊 Dashboard</span>
          </li>
          <li className="nav-item mb-3">
            <a className="nav-link text-white fw-semibold" href="/admin/events">📅 Our Events</a>
            </li>
        </ul>
      </aside>

      {/* Main Section */}
      <main className="flex-grow-1">
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg px-3 py-2">
          <div className="container-fluid d-flex justify-content-between align-items-center">
            <button
              className="btn text-white d-lg-none"
              onClick={() => setSidebarOpen(true)}
            >
              ☰
            </button>
            <span className="navbar-brand fs-4 text-white fw-bold">⚙️ Admin Dashboard</span>
            <button
              className="btn btn-outline-light rounded-pill px-4 fw-medium"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </nav>

        {/* Content */}
        <section className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="fw-bold">👋 Welcome Back, Admin</h2>
            <div className="text-white rounded px-4 py-3 shadow-sm">
              <div className="large text-white">Appointments (last 24h): <span className="fs-4 fw-bold">{stats.appointments_24h}</span> </div>
              <div ></div>
            </div>
          </div>

          <div className="row g-4 mb-5">
            {generalCards.map(([label, count], idx) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={idx}>
                <div className="admin-card glass-card h-100 p-4 text-center">
                  <div className="fs-6 mb-2">{label}</div>
                  <div className="h3 fw-bold">{count}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Tender Partition */}
          <div className="mt-4">
            <h4 className="fw-bold text-white mb-3">📂 Tender Statistics</h4>
            <div className="row g-4">
              <div className="col-12 col-sm-6 col-md-4">
                <div className="admin-card glass-card p-4 text-center">
                  <div className="fs-6 mb-2">💻 Tenders: IT</div>
                  <div className="h3 fw-bold">{stats.tenders.it}</div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4">
                <div className="admin-card glass-card p-4 text-center">
                  <div className="fs-6 mb-2">⚖️ Tenders: Grievances</div>
                  <div className="h3 fw-bold">{stats.tenders.grievances}</div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4">
                <div className="admin-card glass-card p-4 text-center">
                  <div className="fs-6 mb-2">📁 Tenders: Other</div>
                  <div className="h3 fw-bold">{stats.tenders.others}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default AdminDashboard;
